var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-model-bottom',{attrs:{"show":_vm.show},on:{"close":_vm.close}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }